import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomStarRatingComponent } from './custom-star-rating.component';
import {CustomIconsModule} from '../../../../../custom/icons/custom-icons.module';
import {CmsConfig, ConfigModule} from '@spartacus/core';
import {CustomHamburguerMenuComponent} from '../../../layout/header/custom-hamburguer-menu/custom-hamburguer-menu.component';



@NgModule({
  declarations: [CustomStarRatingComponent],
  exports: [CustomStarRatingComponent],
  imports: [
    CommonModule,
   CustomIconsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        StarRatingComponent: {
          component: CustomStarRatingComponent,
        },
      },
    } as CmsConfig)
  ]
})
export class CustomStarRatingModule { }
